import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { Motif } from '../../modules/reclamation/models/motifreclamation';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class MotifreclamationService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/motifreclamation/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  } 
    
    constructor(private http: HttpClient) { }
    public motifreclamations: Motif[] = [
    
    ];
    public motifreclamations$ = new Subject<Motif[]>();
 
    createwithoutfile(motif: Motif) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();
        this.http.post(`${baseUrl}`, motif).subscribe(
          (response) => {
            resolve(response);

          },
          (error) => {
            reject(error);
          },
        );
      });
    }
    getmotifreclamationss() {
      const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}`).subscribe(
          (motifreclamations: Motif[]) => {
            if (motifreclamations) {
              this.motifreclamations = motifreclamations;
              this.emitmotifreclamationss();

            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    
      emitmotifreclamationss() {
        this.motifreclamations$.next(this.motifreclamations);
      }
      getMotifreclamationreqById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error); 
            }
          );
        });
      }
      getmotifreclamation(userId: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}`,{userId}).subscribe(
            (motifreclamations: Motif[]) => {
              if (motifreclamations) {
                this.motifreclamations = motifreclamations;
                this.emitmotifreclamationss();
              }
            },
            (error) => {
              console.log(error);
            }
          );
        });
      }
      
   /* geexistenttmotifreclamation(userId: string,annee:string,mois:string,source:string) 
    {
return new Promise((resolve, reject) => {
        this.http.post(API_URL_cloud+'/anneemois/',{userId,annee,mois,source}).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });

      }*/
      
    /*  create(motifreclamation: Motif) {
        return new Promise((resolve, reject) => {
          
          this.http.post(API_URL_cloud, motifreclamation).subscribe(
            (response) => {
              resolve(response);

            },
            (error) => {
              reject(error);
            },
          );
        });
      }*/
    
     
    
     /* modify(id: string, motifreclamationreq: Motif, image: File | string) {
        return new Promise((resolve, reject) => {
          let motifreclamationreqData: Motif | FormData;
          if (typeof image === 'string') {
            
            motifreclamationreqData = motifreclamationreq;
          } else {
            motifreclamationreqData = new FormData();
            motifreclamationreqData.append('motifreclamationreq', JSON.stringify(motifreclamationreq));
            motifreclamationreqData.append('image', image, motifreclamationreq.email);
          }
          this.http.put(API_URL_cloud + id, motifreclamationreqData).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }*/
      modifymotifreclamationreqById(id: string, motifreclamation: Motif) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.put(`${baseUrl}${id}`, motifreclamation).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        }); 
      }
     /* completemotifreclamationreqById(id: string, motifreclamation: Motif) {
        return new Promise((resolve, reject) => {
          
            
          
          this.http.put(API_URL_cloud+'modify/'+ id, motifreclamation).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }*/
    
      deletemotifreclamationById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }  
      deletemotifreclamationss() {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
    }
